export default __webpack_public_path__ + "static/media/listing-02.b8a39c12.jpg";